import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { role_fitment_data_Loading: true, role_fitment_data_Data: {}, role_fitment_data_Error: false };

export function role_fitment_data_Reducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_ROLE_FITMENT_DATA:
            return {
                role_fitment_data_Loading: true,
                role_fitment_data_Data: {},
                role_fitment_data_Error: false
            };
        case AnalyzeConstants.RECEIVE_ROLE_FITMENT_DATA:
            return {
                role_fitment_data_Loading: false,
                role_fitment_data_Data: action.res,
                role_fitment_data_Error: false
            };
        case AnalyzeConstants.ERROR_ROLE_FITMENT_DATA:
            return {
                role_fitment_data_Loading: false,
                role_fitment_data_Data: {},
                role_fitment_data_Error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/role_fitment_data.reducer.js